const SCREEN_NAMES = {
  LOGIN: 'login',
  REGISTER: 'register',
  VERIFY_AGE: 'verify-age',
  CASTING_BILLBOARD: 'casting-billboard',
  MEDIA_BANK: 'media-bank',
  ACCOUNT_DETAILS: 'account-details',
  NAVIGATION_LINK: 'navigation-link',
  PROFILE_VIEW: 'profile-view',
  CUSTOMIZE_SUBMISSION: 'customize-submission',
};

export default SCREEN_NAMES;
